<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row justify="center">
        <imageCard 
          v-for="(image, index) in images" :key="index"   
          :image="image"  
        >
        </imageCard>

        </v-row>
      </v-col>
    </v-row>
 </v-container>
</template>

<script>
  import imageCard  from "@/components/imageCard";
  import {mapActions } from "vuex";
export default {
  
  name: "Home",
  components: {
    imageCard
  },
  data() {
    return {
      images: [],
      filter: "breakfast"
    }
  }, 
  methods: {
    ...mapActions(['getDinnerMenue']),
    find() {
      this.getDinnerMenue().then(result =>{
        this.images =   result.data;
         console.log(result)
      }) 
    }
  }, 
  mounted() {
    this.find();
  }
}
</script>

<style>

</style>